const isIpAddress = (input: string) => {
  const ipv4 = /(\b25[0-5]|\b2[0-4][0-9]|\b[01]?[0-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}/gm

  return ipv4.test(input)
}

export const getDomainFromHostname = (hostname: string = window.location.hostname): string => {
  if (hostname.indexOf('.') === -1) {
    return ''
  }
  const parts = hostname.toLowerCase().split('.')
  return parts[parts.length - 1]
}

// extract hostname (will be null if no match is found)
function getHostNameFromUrl(url: string) {
  if (!url) {
    return null
  }
  const matches = url.match(/^(https|http)?:\/\/([^/?#]+)(?:[/?#]|$)/i)
  return matches && matches[2]
}

/**
 * Client-side helper only, not meant for server-side
 * Deciding when its an internal DHL api call or external 3rd party like mopinion, etc
 */
export function isInternalUrl(url: string): boolean {
  const hostName = getHostNameFromUrl(url)
  // if the hostName is null then it is just a path and that means it is on a DHL host
  return hostName ? hostName === window?.location?.hostname : true
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const isDomainNL = (hostname: string = window.location.hostname): boolean =>
  getDomainFromHostname(hostname) === 'nl'

// eslint-disable-next-line @typescript-eslint/naming-convention
export const isDomainSE = (hostname: string = window.location.hostname): boolean =>
  getDomainFromHostname(hostname) === 'se'

export const isLocalhost = (hostname: string = window.location.hostname): boolean =>
  !window.Cypress && (hostname.includes('localhost') || hostname.includes('macbook-') || isIpAddress(hostname))

export const getCountryCodeFromHostname = (hostname: string = window.location.hostname): string => {
  const defaultValue = 'NL'

  if (isIpAddress(hostname)) {
    return defaultValue
  }

  const domain = getDomainFromHostname(hostname)

  // Extract the country code from the host domain name with a default value of 'NL'
  return domain === '' ? defaultValue : domain.toUpperCase()
}
